import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureEntitlements } from './featureEntitlements'
import { FeatureToggle } from './featureToggles'

/**
 * Access control configuration for viewing delivery software routes.
 *
 * Requires:
 * - Permission: partner_bulk_delivery_route.view
 * - Entitlement: fulfillment.delivery_software.partner_bulk_delivery_enabled
 * - Warehouse Feature Toggle: rt_delivery_software (scoped to retailer/warehouse). Note this is only
 *   needed for development and first launch. We can remove this toggle and rely on entitlements alone
 *   after the first retailer launch.
 *
 * This ensures only retailers with delivery software enabled and users with
 * the appropriate role can access route management features.
 */
export const deliverySoftwareAccessControl: DomainAccessControlConfig = [
  {
    permissions: Permission.PartnerBulkDeliveryRouteView,
    featureEntitlementIds: [FeatureEntitlements.PartnerBulkDeliveryEnabled],
    warehouseFeatureToggles: [FeatureToggle.deliverySoftware],
    restrictedBannersAllowed: true,
  },
]

/**
 * Access control configuration for editing delivery software routes.
 *
 * Requires:
 * - Permission: partner_bulk_delivery_route.modify
 *
 * This gates route editing capabilities (reorder, add/remove orders, cancel routes).
 */
export const deliverySoftwareEditAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.PartnerBulkDeliveryRouteModify],
    restrictedBannersAllowed: true,
  },
]
